<template>
  <div class="business-synergy bg--color-01">
    <div class="container-wrapper bg--color-11">
      <div class="business-synergy__container container-new">
        <span
          class="txt txt--36px txt--height-44px txt--44px--m txt--height-58px--m txt--color-04 txt--bold txt--center--m"
        >
          {{ $t('business.businessSynergy.title') }}
        </span>

        <span
          class="txt txt--16px txt--height-20px txt--22px--m txt--height-30px--m txt--color-04 txt--center--m"
        >
          {{ $t('business.businessSynergy.desc') }}
        </span>

        <div class="business-synergy__cols mt-24 mt-32--m">
          <div
            v-for="(col, index) in columns"
            :key="index"
            class="business-synergy__col p-24 bg--color-01"
          >
            <span class="txt txt--36px txt--height-44px txt--color-04">
              {{ col.title }}
              <span class="underlined txt--bold">{{ col.headTitle }}</span>
            </span>

            <span
              class="txt txt--16px txt--height-20px txt--color-04 txt--bold pt-16"
            >
              {{ col.subtitle }}
            </span>

            <div class="business-synergy__col-items mt-24 mt--32--m">
              <div
                v-for="(item, itemIndex) in col.items || []"
                :key="itemIndex"
                class="business-synergy__col-item"
              >
                <img src="@/assets/img/business/senergy/star.svg">
                <span
                  class="txt txt--16px txt--height-20px txt--22px--m txt--height-30px--m txt--color-04"
                >
                  {{ item }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    columns () {
      return [
        {
          title: this.$t('business.businessSynergy.tokenFor.title'),
          headTitle: 'С-Раtех',
          subtitle: this.$t('business.businessSynergy.tokenFor.desc'),
          items: this.$t('business.businessSynergy.tokenFor.list'),
        },
        {
          title: this.$t('business.businessSynergy.cpatexFor.title'),
          headTitle: this.$t('business.businessSynergy.cpatexFor.subTitle'),
          subtitle: this.$t('business.businessSynergy.cpatexFor.desc'),
          items: this.$t('business.businessSynergy.cpatexFor.list'),
        },
      ]
    },
  },
}
</script>

<style lang="scss" scoped>
.business-synergy {
  &__container {
    display: flex;
    flex-direction: column;
    gap: toRem(24px);
  }

  &__cols {
    display: grid;
    grid-template-columns: 1fr;
    gap: toRem(24px);

    @include bp(m) {
      grid-template-columns: 1fr 1fr;
      align-items: flex-start;
      gap: toRem(48px);
    }
  }

  &__col {
    border-radius: toRem(20px);
    display: flex;
    flex-direction: column;
  }

  &__col-items {
    display: flex;
    flex-direction: column;
    gap: toRem(20px);

    @include bp(m) {
      gap: toRem(24px);
    }
  }

  &__col-item {
    display: grid;
    grid-template-columns: toRem(30px) 1fr;
    gap: toRem(24px);
    align-items: center;

    img {
      max-width: toRem(30px);
      width: 100%;
    }
  }

  &__items {
    display: flex;
    flex-direction: column;
    gap: toRem(22px);

    @include bp(m) {
      gap: toRem(27px);
    }
  }

  &__img {
    width: 100%;
    margin: 0 auto;

    @include bp(0, m) {
      max-width: toRem(400px);
    }

    @include bp(m) {
      max-width: toRem(600px);
      margin: unset;
    }
  }

  &__item {
    display: grid;
    grid-template-columns: toRem(17px) 1fr;
    align-items: center;
    gap: toRem(16px);
  }

  &__circle {
    width: toRem(17px);
    height: toRem(17px);
    border-radius: 100%;
  }

  .underlined {
    position: relative;
    white-space: nowrap;
    z-index: 3;

    &::before {
      content: '';
      background: url('@/assets/img/business/senergy/vector.svg');
      background-position: top;
      background-repeat: no-repeat;
      background-size: 100%;
      display: block;
      position: absolute;
      bottom: toRem(-30px);
      left: 0;
      width: 100%;
      height: toRem(40px);
      z-index: -2;

      @include bp(l) {
        bottom: toRem(-30px);
      }
    }
  }
}
</style>
